import React from 'react'

import PropTypes from 'prop-types'

import './social.css'

const Social = (props) => {
  return (
    <div className={`social-social ${props.rootClassName} `}>
      <img
        alt={props.insiderAlt}
        src={props.insiderSrc}
        className="social-insider"
      />
    </div>
  )
}

Social.defaultProps = {
  rootClassName: '',
  insiderAlt: 'pastedImage',
  insiderSrc:
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/488d446d-f740-467d-9844-7dabd0ad3955/dc84e660-6f14-43e9-80e8-dbcb1fbaae0f?org_if_sml=1&force_format=original',
}

Social.propTypes = {
  rootClassName: PropTypes.string,
  insiderAlt: PropTypes.string,
  insiderSrc: PropTypes.string,
}

export default Social
